import script from "./DraggablePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DraggablePanel.vue?vue&type=script&setup=true&lang=js"

import "./DraggablePanel.vue?vue&type=style&index=0&id=796c71e7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-796c71e7"]])

export default __exports__